import { Membership } from "./membership";
import { Nomination } from "./nomination";
import { OrganizationPayoutFormat } from "./organizationPayoutFormat";
import { PointSeries } from "./point-series";
import { Secretary } from "./secretary";

export class Organization {
    id: number;
    name: string;
    defaultSecretary: Secretary;
    paymentRequiredOnEntry: boolean;
    logoFileName: string;

    nominations: Nomination[];
    memberships: Membership[];
    payoutFormats: OrganizationPayoutFormat[];
    pointSeries: PointSeries[];

    requireMembershipOrEventPassForEntries: boolean;

    maxContestantDoctorReleaseTurnoutsPerSeason: number;
    maxContestantVetReleaseTurnoutsPerSeason: number;

    turnoutFeeDoctorsRelease: number;
    turnoutFeeVetRelease: number;
    turnoutFeeNotified: number;
    turnoutFeeNonNotified: number;
    turnoutFeeNotifiedPerformance: number; 
    turnoutFeeNonNotifiedPerformance: number;
    turnoutFeeNotifiedNonPreference: number;
    turnoutFeeNonNotifiedNonPreference: number;
    turnoutFeeNotifiedSlack: number;
    turnoutFeeNonNotifiedSlack: number;

    turnoutGraceDeadlineHours: number;
}


// WEBPACK FOOTER //
// ./src/model/organization.ts